let data = undefined;

function domainSetup() {
   "use strict";
   return new Promise((resolve, reject) => {
      $.ajax('/api/domain/setup', {
            async: false,
            cache: true,
            contentType: 'application/json',
            timeout: 10000
         })
         .done(function done(result) {
            if (result) {
               data = result;
               resolve(result);
               return result;
            }
         }).fail(function fail(xhr, textStatus, errorThrown) {
            // could fall back to env values, alert(xhr.statusText), or just continue...
            console.debug(`failure loading dns config. ${textStatus} = [${errorThrown}]`);
            reject();
         })
         .always(function always(response) {
            // this will always be called whether the call succeeds or fails
         });
   });
}

export default function(callBack) {
   "use strict";

   if (typeof data !== 'undefined') {
      callBack(data); // If data is already defined, don't wait
   } else {
      domainSetup().then((value) => {
         callBack(value);
      });
   }
}
